import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import LinkExternal from '@material-ui/core/Link';
import styled from 'styled-components';

const LinkHeaderMenu = styled(Link)`
    text-decoration: none;
    color: ${props => props.theme.palette.primary.main};
    font-weight: ${props => props.active && 'bold'};
    &:hover {
        text-decoration: underline
    }
`;

const MenuButton = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
        <Fragment>
            <IconButton color="inherit" aria-label="menu" onClick={handleClick}>
                <MenuIcon />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}><LinkHeaderMenu to="/">ホーム</LinkHeaderMenu></MenuItem>
                <MenuItem onClick={handleClose}><LinkHeaderMenu to="/about">小麦屋について</LinkHeaderMenu></MenuItem>
                <MenuItem onClick={handleClose}><LinkHeaderMenu to="/gallery">ギャラリー</LinkHeaderMenu></MenuItem>
                <MenuItem onClick={handleClose}><LinkHeaderMenu to="/access">アクセス</LinkHeaderMenu></MenuItem>
                <MenuItem onClick={handleClose}>
                    <LinkExternal target="_blank" href="https://www.instagram.com/komugiya_yaizu/">
                        <Typography align="center">インスタグラム</Typography>
                    </LinkExternal>
                </MenuItem>
            </Menu>
        </Fragment>
    )
}

export default MenuButton;